export const API_URL = process.env.REACT_APP_API_URL;

export const API_ROUTES = {
  SIGN_UP: `${API_URL}/api/auth/signup`,
  SIGN_IN: `${API_URL}/api/auth/login`,// URL pointant vers la route de connexion authentifiée
  PROJETS: `${API_URL}/api/projects`,
  CONTACT: `${API_URL}/api/contact`,
};

console.log("API_URL =", API_URL);
console.log("PROJECTS =", API_ROUTES.PROJETS);

export const APP_ROUTES = {
  SIGN_UP: "/Inscription",
  SIGN_IN: "/Connexion",
  HOME: "/",
  // NOMATCH: "/NoMatch",
  APROPOS: "/Apropos",
  CONTACT: "/Contact",
  ADD_PROJET: "/Ajouter",
  PROJETS: "/Projets",
  PROJET: "/FicheProjet/:id",//projets remplacé par "FicheProjet" 
  UPDATE_PROJET: "/projet/modifier/:id",
};

